import React from "react";
import "../../assets/css/serviciosContables.css";
const ServiciosContablesCard = ({
  titulo,
  subtitulo,
  descripcion,
  className,
  icon,
}) => (
  <div className={`ServiciosContablesCard ${className}`}>
    <div className="barraAmarillaContable">
      <h4 className="tituloContable">{subtitulo}</h4>
      <h2 className="subtituloContable">{titulo}</h2>
    </div>

    <div className="contenidoContable">
      {icon && <img src={icon} alt={titulo} className="iconContable" />}
    </div>

    <div className="textoContable">
      <p>{descripcion}</p>
    </div>
  </div>
);

export default ServiciosContablesCard;
